import { render } from "./HelpArticleViewer.vue?vue&type=template&id=c55d9d5a"
import script from "./HelpArticleViewer.vue?vue&type=script&lang=js"
export * from "./HelpArticleViewer.vue?vue&type=script&lang=js"

import "./HelpArticleViewer.vue?vue&type=style&index=0&id=c55d9d5a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__